export default __webpack_public_path__ + "static/media/51.8563fb24.png";